import { render, staticRenderFns } from "./buildLoginCom.vue?vue&type=template&id=4ebe6914&scoped=true"
import script from "./buildLoginCom.vue?vue&type=script&lang=js"
export * from "./buildLoginCom.vue?vue&type=script&lang=js"
import style0 from "./buildLoginCom.vue?vue&type=style&index=0&id=4ebe6914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe6914",
  null
  
)

export default component.exports